import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Image from 'next/image';

interface NewFooterMobileProps {
  t: any;
  locale: string;
}

interface AccordionState {
  [key: string]: boolean;
}

export const NewFooterMobile: React.FC<NewFooterMobileProps> = ({ t, locale }) => {
  const [accordionState, setAccordionState] = useState<AccordionState>({});

  const toggleAccordion = (key: string) => {
    setAccordionState(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // Category data for accordion
  const categoryData = [
    {
      category: 'คอนโด',
      key: 'condo',
      links: [
        { text: 'ซื้อขาย คอนโด', link: '/ขาย/คอนโด' },
        { text: 'ให้เช่า คอนโด', link: '/ให้เช่า/คอนโด' },
        { text: 'คอนโด ใกล้ ฉัน', link: '/ขาย/คอนโด' },
        { text: 'คอนโด 2 ห้องนอน', link: '/' },
        { text: 'คอนโด มือสองราคาถูก', link: '/ขาย/คอนโด' },
        { text: 'คอนโด ติดรถไฟฟ้า', link: '/ขาย/คอนโด/รถไฟฟ้า' },
        { text: 'คอนโด ติด BTS', link: '/ขาย/คอนโด/รถไฟฟ้า/BTS---สายสุขุมวิท' },
        { text: 'คอนโด ใกล้ MRT', link: '/ขาย/คอนโด/รถไฟฟ้า/MRT---สายสีน้ำเงิน' },
        { text: 'คอนโด พระราม 9', link: '/ขาย/คอนโด/ถนน/พระราม-9' },
        { text: 'คอนโด สุขุมวิท', link: '/ขาย/คอนโด/ถนน/สุขุมวิท' },
        { text: 'คอนโด อโศก', link: '/ขาย/คอนโด/ถนน/อโศกมนตรี' },
        { text: 'คอนโด ทองหล่อ', link: '/ขาย/คอนโด/ถนน/ทองหล่อ' },
        { text: 'คอนโด เอกมัย', link: '/ขาย/คอนโด/ถนน/เอกมัย' },
        { text: 'คอนโด อ่อนนุช', link: '/ขาย/คอนโด/ถนน/อ่อนนุช' },
        { text: 'คอนโด อุดมสุข', link: '/ขาย/คอนโด/ถนน/อุดมสุข' },
        { text: 'คอนโด รัชดา', link: '/ขาย/คอนโด/ถนน/รัชดาภิเษก' },
        { text: 'คอนโด แจ้งวัฒนะ', link: '/ขาย/คอนโด/ถนน/แจ้งวัฒนะ' },
        { text: 'คอนโด สามย่าน', link: '/ขาย/คอนโด/รถไฟฟ้า/MRT---สายสีน้ำเงิน/MRT-สามย่าน-(BL27)' },
        { text: 'คอนโด สาทร', link: '/ขาย/คอนโด/ถนน/สาทร' },
        { text: 'คอนโด รามอินทรา', link: '/ขาย/คอนโด/ถนน/รามอินทรา' },
        { text: 'คอนโด อารีย์', link: '/ขาย/คอนโด/รถไฟฟ้า/BTS---สายสุขุมวิท/BTS-อารีย์-(N5)' },
        { text: 'คอนโด ปิ่นเกล้า', link: '/ขาย/คอนโด/ถนน/ปิ่นเกล้า' },
        { text: 'คอนโด พระราม 3', link: '/ขาย/คอนโด/ถนน/พระราม-3' },
        { text: 'คอนโด สะพานควาย', link: '/ขาย/คอนโด/รถไฟฟ้า/BTS---สายสุขุมวิท/BTS-สะพานควาย-(N7)' },
        { text: 'คอนโด พระราม 2', link: '/ขาย/คอนโด/ถนน/พระราม-2' },
        { text: 'คอนโด ท่าพระ', link: '/ขาย/คอนโด/รถไฟฟ้า/MRT---สายสีน้ำเงิน/MRT-ท่าพระ-(BL01)' },
        { text: 'คอนโด พัทยา', link: '/ขาย/คอนโด/ชลบุรี/บางละมุง/เมืองพัทยา' },
        { text: 'คอนโด เชียงใหม่', link: '/ขาย/คอนโด/เชียงใหม่' },
        { text: 'คอนโด หัวหิน', link: '/ขาย/คอนโด/ประจวบคีรีขันธ์/หัวหิน' },
        { text: 'คอนโด ภูเก็ต', link: '/ขาย/คอนโด/ภูเก็ต' }
      ]
    },
    {
      category: 'บ้านเดี่ยว',
      key: 'house',
      links: [
        { text: 'ซื้อขาย บ้านเดี่ยว', link: '/ขาย/บ้านเดี่ยว' },
        { text: 'ให้เช่า บ้านเดี่ยว', link: '/ให้เช่า/บ้านเดี่ยว' },
        { text: 'บ้านเดี่ยว มือสองราคาถูก', link: '/ขาย/บ้านเดี่ยว' },
        { text: 'บ้านเดี่ยว กรุงเทพฯ', link: '/ขาย/บ้านเดี่ยว/กรุงเทพฯ' },
        { text: 'บ้านเดี่ยว นนทบุรี', link: '/ขาย/บ้านเดี่ยว/นนทบุรี' },
        { text: 'บ้านเดี่ยว ปทุมธานี', link: '/ขาย/บ้านเดี่ยว/ปทุมธานี' },
        { text: 'บ้านเดี่ยว สมุทรปราการ', link: '/ขาย/บ้านเดี่ยว/สมุทรปราการ' },
        { text: 'บ้านเดี่ยว นครปฐม', link: '/ขาย/บ้านเดี่ยว/นครปฐม' },
        { text: 'บ้านเดี่ยว ชลบุรี', link: '/ขาย/บ้านเดี่ยว/ชลบุรี' },
        { text: 'บ้านเดี่ยว เชียงใหม่', link: '/ขาย/บ้านเดี่ยว/เชียงใหม่' },
        { text: 'บ้านเดี่ยว นครราชสีมา', link: '/ขาย/บ้านเดี่ยว/นครราชสีมา' },
        { text: 'บ้านเดี่ยว พระราม 9', link: '/ขาย/บ้านเดี่ยว/ถนน/พระราม-9' },
        { text: 'บ้านเดี่ยว ลาดพร้าว', link: '/ขาย/บ้านเดี่ยว/กรุงเทพฯ/ลาดพร้าว' },
        { text: 'บ้านเดี่ยว รามอินทรา', link: '/ขาย/บ้านเดี่ยว/ถนน/รามอินทรา' },
        { text: 'บ้านเดี่ยว วัชรพล', link: '/ขาย/บ้านเดี่ยว/ถนน/วัชรพล' },
        { text: 'บ้านเดี่ยว รามคำแหง', link: '/ขาย/บ้านเดี่ยว/ถนน/รามคำแหง' },
        { text: 'บ้านเดี่ยว พัฒนาการ', link: '/ขาย/บ้านเดี่ยว/ถนน/พัฒนาการ' },
        { text: 'บ้านเดี่ยว กรุงเทพกรีฑา', link: '/ขาย/บ้านเดี่ยว/ถนน/กรุงเทพกรีฑา' },
        { text: 'บ้านเดี่ยว นวมินทร์', link: '/ขาย/บ้านเดี่ยว/ถนน/นวมินทร์' },
        { text: 'บ้านเดี่ยว อ่อนนุช', link: '/ขาย/บ้านเดี่ยว/ถนน/อ่อนนุช' },
        { text: 'บ้านเดี่ยว ศรีนครินทร์', link: '/ขาย/บ้านเดี่ยว/ถนน/ศรีนครินทร์' },
        { text: 'บ้านเดี่ยว ลาดกระบัง', link: '/ขาย/บ้านเดี่ยว/ถนน/ลาดกระบัง' },
        { text: 'บ้านเดี่ยว บางนา ตราด', link: '/ขาย/บ้านเดี่ยว/ถนน/บางนา-ตราด' },
        { text: 'บ้านเดี่ยว เทพารักษ์', link: '/ขาย/บ้านเดี่ยว/ถนน/เทพารักษ์' },
        { text: 'บ้านเดี่ยว พระราม 2', link: '/ขาย/บ้านเดี่ยว/ถนน/พระราม-2' },
        { text: 'บ้านเดี่ยว สุขสวัสดิ์', link: '/ขาย/บ้านเดี่ยว/ถนน/สุขสวัสดิ์' },
        { text: 'บ้านเดี่ยว ราชพฤกษ์', link: '/ขาย/บ้านเดี่ยว/ถนน/ราชพฤกษ์' },
        { text: 'บ้านเดี่ยว นครอินทร์', link: '/ขาย/บ้านเดี่ยว/ถนน/นครอินทร์' },
        { text: 'บ้านเดี่ยว เพชรเกษม', link: '/ขาย/บ้านเดี่ยว/ถนน/เพชรเกษม' },
        { text: 'บ้านเดี่ยว กัลปพฤกษ์', link: '/ขาย/บ้านเดี่ยว/ถนน/กัลปพฤกษ์' }
      ]
    },
    {
      category: 'ทาวน์เฮ้าส์-โฮม',
      key: 'townhouse',
      links: [
        { text: 'ซื้อขาย ทาวน์เฮ้าส์-โฮม', link: '/ขาย/ทาวน์เฮ้าส์-โฮม' },
        { text: 'ให้เช่า ทาวน์เฮ้าส์-โฮม', link: '/ให้เช่า/ทาวน์เฮ้าส์-โฮม' },
        { text: 'ทาวน์เฮ้าส์-โฮม มือสองราคาถูก', link: '/ขาย/ทาวน์เฮ้าส์-โฮม' },
        { text: 'ทาวน์เฮ้าส์-โฮม กรุงเทพฯ', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/กรุงเทพฯ' },
        { text: 'ทาวน์เฮ้าส์-โฮม นนทบุรี', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/นนทบุรี' },
        { text: 'ทาวน์เฮ้าส์-โฮม ปทุมธานี', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ปทุมธานี' },
        { text: 'ทาวน์เฮ้าส์-โฮม สมุทรปราการ', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/สมุทรปราการ' },
        { text: 'ทาวน์เฮ้าส์-โฮม นครปฐม', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/นครปฐม' },
        { text: 'ทาวน์เฮ้าส์-โฮม ชลบุรี', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ชลบุรี' },
        { text: 'ทาวน์เฮ้าส์-โฮม เชียงใหม่', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/เชียงใหม่' },
        { text: 'ทาวน์เฮ้าส์-โฮม นครราชสีมา', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/นครราชสีมา' },
        { text: 'ทาวน์เฮ้าส์-โฮม พระราม 9', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/พระราม-9' },
        { text: 'ทาวน์เฮ้าส์-โฮม ลาดพร้าว', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/กรุงเทพฯ/ลาดพร้าว' },
        { text: 'ทาวน์เฮ้าส์-โฮม รามอินทรา', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/รามอินทรา' },
        { text: 'ทาวน์เฮ้าส์-โฮม วัชรพล', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/วัชรพล' },
        { text: 'ทาวน์เฮ้าส์-โฮม รามคำแหง', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/รามคำแหง' },
        { text: 'ทาวน์เฮ้าส์-โฮม พัฒนาการ', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/พัฒนาการ' },
        { text: 'ทาวน์เฮ้าส์-โฮม กรุงเทพกรีฑา', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/กรุงเทพกรีฑา' },
        { text: 'ทาวน์เฮ้าส์-โฮม นวมินทร์', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/นวมินทร์' },
        { text: 'ทาวน์เฮ้าส์-โฮม อ่อนนุช', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/อ่อนนุช' },
        { text: 'ทาวน์เฮ้าส์-โฮม ศรีนครินทร์', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/ศรีนครินทร์' },
        { text: 'ทาวน์เฮ้าส์-โฮม ลาดกระบัง', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/ลาดกระบัง' },
        { text: 'ทาวน์เฮ้าส์-โฮม บางนา ตราด', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/บางนา-ตราด' },
        { text: 'ทาวน์เฮ้าส์-โฮม เทพารักษ์', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/เทพารักษ์' },
        { text: 'ทาวน์เฮ้าส์-โฮม พระราม 2', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/พระราม-2' },
        { text: 'ทาวน์เฮ้าส์-โฮม สุขสวัสดิ์', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/สุขสวัสดิ์' },
        { text: 'ทาวน์เฮ้าส์-โฮม ราชพฤกษ์', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/ราชพฤกษ์' },
        { text: 'ทาวน์เฮ้าส์-โฮม นครอินทร์', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/นครอินทร์' },
        { text: 'ทาวน์เฮ้าส์-โฮม เพชรเกษม', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/เพชรเกษม' },
        { text: 'ทาวน์เฮ้าส์-โฮม กัลปพฤกษ์', link: '/ขาย/ทาวน์เฮ้าส์-โฮม/ถนน/กัลปพฤกษ์' }
      ]
    },
    {
      category: 'ที่ดิน',
      key: 'land',
      links: [
        { text: 'ซื้อขาย ที่ดิน', link: '/ขาย/ที่ดิน/' },
        { text: 'ให้เช่า ที่ดิน', link: '/ให้เช่า/ที่ดิน/' },
        { text: 'ที่ดิน ราคาถูก', link: '/ขาย/ที่ดิน/' },
        { text: 'ที่ดิน เปล่า', link: '/ขาย/ที่ดิน/รูปแบบ/ที่ดินเปล่า' },
        { text: 'ที่ดิน กรุงเทพฯ', link: '/ขาย/ที่ดิน/กรุงเทพฯ' },
        { text: 'ที่ดิน สมุทรปราการ', link: '/ขาย/ที่ดิน/สมุทรปราการ' },
        { text: 'ที่ดิน นนทบุรี', link: '/ขาย/ที่ดิน/นนทบุรี' },
        { text: 'ที่ดิน ปทุมธานี', link: '/ขาย/ที่ดิน/ปทุมธานี' },
        { text: 'ที่ดิน นครปฐม', link: '/ขาย/ที่ดิน/นครปฐม' },
        { text: 'ที่ดิน สมุทรสาคร', link: '/ขาย/ที่ดิน/สมุทรสาคร' },
        { text: 'ที่ดิน ฉะเชิงเทรา', link: '/ขาย/ที่ดิน/ฉะเชิงเทรา' },
        { text: 'ที่ดิน ชลบุรี', link: '/ขาย/ที่ดิน/ชลบุรี' },
        { text: 'ที่ดิน ศรีราชา', link: '/ขาย/ที่ดิน/ชลบุรี/ศรีราชา' },
        { text: 'ที่ดิน พัทยา', link: '/ขาย/ที่ดิน/ชลบุรี/บางละมุง/เมืองพัทยา' },
        { text: 'ที่ดิน ระยอง', link: '/ขาย/ที่ดิน/ระยอง' },
        { text: 'ที่ดิน จันทบุรี', link: '/ขาย/ที่ดิน/จันทบุรี' },
        { text: 'ที่ดิน ตราด', link: '/ขาย/ที่ดิน/ตราด' },
        { text: 'ที่ดิน สระบุรี', link: '/ขาย/ที่ดิน/สระบุรี' },
        { text: 'ที่ดิน ปราจีนบุรี', link: '/ขาย/ที่ดิน/ปราจีนบุรี' },
        { text: 'ที่ดิน เชียงใหม่', link: '/ขาย/ที่ดิน/เชียงใหม่' },
        { text: 'ที่ดิน นครราชสีมา', link: '/ขาย/ที่ดิน/นครราชสีมา' },
        { text: 'ที่ดิน ศรีนครินทร์', link: '/ขาย/ที่ดิน/ถนน/ศรีนครินทร์' },
        { text: 'ที่ดิน รามอินทรา', link: '/ขาย/ที่ดิน/ถนน/รามอินทรา' },
        { text: 'ที่ดิน กาญจนบุรี', link: '/ขาย/ที่ดิน/กาญจนบุรี' },
        { text: 'ที่ดิน วังน้ำเขียว', link: '/ขาย/ที่ดิน/นครราชสีมา/วังน้ำเขียว' },
        { text: 'ที่ดิน ปากช่อง', link: '/ขาย/ที่ดิน/นครราชสีมา/ปากช่อง' },
        { text: 'ที่ดิน ขอนแก่น', link: '/ขาย/ที่ดิน/ขอนแก่น' },
        { text: 'ที่ดิน นครศรีธรรมราช', link: '/ขาย/ที่ดิน/นครศรีธรรมราช' },
        { text: 'ที่ดิน เชียงราย', link: '/ขาย/ที่ดิน/เชียงราย' },
        { text: 'ที่ดิน สงขลา', link: '/ขาย/ที่ดิน/สงขลา' }
      ]
    },
    {
      category: 'โรงงาน',
      key: 'factory',
      links: [
        { text: 'ซื้อขาย โรงงาน', link: '/ขาย/โรงงาน' },
        { text: 'ให้เช่า โรงงาน', link: '/ให้เช่า/โรงงาน' },
        { text: 'โรงงาน ราคาถูก', link: '/ขาย/โรงงาน' },
        { text: 'โรงงาน กรุงเทพฯ', link: '/ขาย/โรงงาน/กรุงเทพฯ' },
        { text: 'โรงงาน ลาดกระบัง', link: '/ขาย/โรงงาน/กรุงเทพฯ/ลาดกระบัง' },
        { text: 'โรงงาน บางขุนเทียน', link: '/ขาย/โรงงาน/กรุงเทพฯ/บางขุนเทียน' },
        { text: 'โรงงาน เอกชัย', link: '/ขาย/โรงงาน/ถนน/เอกชัย' },
        { text: 'โรงงาน พระราม 2', link: '/ขาย/โรงงาน/ถนน/พระราม-2' },
        { text: 'โรงงาน สมุทรปราการ', link: '/ขาย/โรงงาน/สมุทรปราการ' },
        { text: 'โรงงาน บางพลี', link: '/ขาย/โรงงาน/สมุทรปราการ/บางพลี' },
        { text: 'โรงงาน บางเสาธง', link: '/ขาย/โรงงาน/สมุทรปราการ/บางเสาธง' },
        { text: 'โรงงาน บางบ่อ', link: '/ขาย/โรงงาน/สมุทรปราการ/บางบ่อ' },
        { text: 'โรงงาน พระสมุทรเจดีย์', link: '/ขาย/โรงงาน/สมุทรปราการ/พระสมุทรเจดีย์' },
        { text: 'โรงงาน นนทบุรี', link: '/ขาย/โรงงาน/นนทบุรี' },
        { text: 'โรงงาน ปทุมธานี', link: '/ขาย/โรงงาน/ปทุมธานี' },
        { text: 'โรงงาน นครปฐม', link: '/ขาย/โรงงาน/นครปฐม' },
        { text: 'โรงงาน สมุทรสาคร', link: '/ขาย/โรงงาน/สมุทรสาคร' },
        { text: 'โรงงาน กระทุ่มแบน', link: '/ขาย/โรงงาน/สมุทรสาคร/กระทุ่มแบน' },
        { text: 'โรงงาน ฉะเชิงเทรา', link: '/ขาย/โรงงาน/ฉะเชิงเทรา' },
        { text: 'โรงงาน นครปฐม', link: '/ขาย/โรงงาน/นครปฐม' },
        { text: 'โรงงาน จันทบุรี', link: '/ขาย/โรงงาน/จันทบุรี' },
        { text: 'โรงงาน ชลบุรี', link: '/ขาย/โรงงาน/ชลบุรี' },
        { text: 'โรงงาน บ้านบึง', link: '/ขาย/โรงงาน/ชลบุรี/บ้านบึง' },
        { text: 'โรงงาน ศรีราชา', link: '/ขาย/โรงงาน/ชลบุรี/ศรีราชา' },
        { text: 'โรงงาน ระยอง', link: '/ขาย/โรงงาน/ระยอง' },
        { text: 'โรงงาน ปลวกแดง', link: '/ขาย/โรงงาน/ระยอง/ปลวกแดง' },
        { text: 'โรงงาน บางปะอิน', link: '/ขาย/โรงงาน/พระนครศรีอยุธยา/บางปะอิน' },
        { text: 'โรงงาน ปราจีนบุรี', link: '/ขาย/โรงงาน/ปราจีนบุรี' },
        { text: 'โรงงาน นครราชสีมา', link: '/ขาย/โรงงาน/นครราชสีมา' },
        { text: 'โรงงาน ลำพูน', link: '/ขาย/โรงงาน/ลำพูน' }
      ]
    }
  ];

  // Generate links function - Remove this function as we're now using static data
  const generateLinks = (categoryData) => {
    return categoryData.links;
  };

  // Additional menu items
  const organizationLinks = [
    { text: t('footer.about_us'), link: '/about' },
    { text: t('footer.privacy_policy'), link: '/privacy-policy' },
    { text: t('footer.terms_conditions'), link: '/terms' },
    { text: t('footer.post_for_free'), link: '/post' },
    { text: t('footer.contact_us'), link: '/contact' }
  ];

  const sitemapLinks = [
    { text: 'Sitemap TH', link: '/web-sitemap/th' },
    { text: 'Sitemap EN', link: '/web-sitemap/en' },
    { text: 'Sitemap CN', link: '/web-sitemap/cn' }
  ];

  return (
    <footer style={{
      backgroundColor: '#F5F5F6',
      padding: '24px 0',
      fontFamily: 'Prompt, Inter, Noto Serif SC, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif'
    }}>
      <div style={{
        padding: '0 16px'
      }}>
        {/* Accordion Section */}
        <div style={{ marginBottom: '24px' }}>
          {/* Category Accordions */}
          {categoryData.map((category, index) => {
            const categoryTitle = category.category;
            const links = category.links;
            const isExpanded = accordionState[category.key] || false;

            return (
              <div key={index} style={{ marginBottom: '4px' }}>
                {/* Accordion Header */}
                <div 
                  onClick={() => toggleAccordion(category.key)}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px 0',
                    cursor: 'pointer',
                    background: 'transparent'
                  }}
                >
                  <h5 style={{
                    fontFamily: 'Prompt',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '1.25',
                    color: '#000000',
                    margin: 0
                  }}>
                    {categoryTitle}
                  </h5>
                  
                  {/* Arrow Icon */}
                  <svg 
                    width="12" 
                    height="7" 
                    viewBox="0 0 12 7" 
                    fill="none" 
                    style={{
                      transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease',
                      color: isExpanded ? '#F4762A' : '#919192'
                    }}
                  >
                    <path 
                      d="M1 1L6 6L11 1" 
                      stroke="currentColor" 
                      strokeWidth="1.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {/* Accordion Content */}
                {isExpanded && (
                  <div style={{
                    padding: '12px 0',
                    animation: 'fadeIn 0.3s ease-in-out'
                  }}>
                    <div style={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      gap: '8px' 
                    }}>
                      {links.map((item, linkIndex) => (
                        <a key={linkIndex} href={item.link} style={{
                          fontFamily: 'Prompt',
                          fontWeight: 400,
                          fontSize: '12px',
                          lineHeight: '1.6',
                          color: '#575758',
                          textDecoration: 'none',
                          transition: 'color 0.2s ease',
                          padding: '2px 0'
                        }}>
                          {item.text}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}

          {/* Organization Accordion */}
          <div style={{ marginBottom: '4px' }}>
            <div 
              onClick={() => toggleAccordion('organization')}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px 0',
                cursor: 'pointer',
                background: 'transparent'
              }}
            >
              <h5 style={{
                fontFamily: 'Prompt',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '1.25',
                color: '#000000',
                margin: 0
              }}>
                {t('footer.organization')}
              </h5>
              
              <svg 
                width="12" 
                height="7" 
                viewBox="0 0 12 7" 
                fill="none" 
                style={{
                  transform: accordionState['organization'] ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease',
                  color: accordionState['organization'] ? '#F4762A' : '#919192'
                }}
              >
                <path 
                  d="M1 1L6 6L11 1" 
                  stroke="currentColor" 
                  strokeWidth="1.5" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            {accordionState['organization'] && (
              <div style={{
                padding: '12px 0',
                animation: 'fadeIn 0.3s ease-in-out'
              }}>
                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: '8px' 
                }}>
                  {[
                    // { text: t('footer.about_us'), link: '/about' },
                    { text: t('footer.privacy_policy'), link: '/privacy-policy' },
                    { text: t('footer.terms_conditions'), link: '/terms' },
                    { text: t('footer.post_for_free'), link: '/seller' },
                    // { text: t('footer.contact_us'), link: '/contact' }
                  ].map((item, linkIndex) => (
                    <a key={linkIndex} href={item.link} style={{
                      fontFamily: 'Prompt',
                      fontWeight: 400,
                      fontSize: '12px',
                      lineHeight: '1.6',
                      color: '#575758',
                      textDecoration: 'none',
                      transition: 'color 0.2s ease',
                      padding: '2px 0'
                    }}>
                      {item.text}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Sitemap Accordion */}
          <div style={{ marginBottom: '4px' }}>
            <div 
              onClick={() => toggleAccordion('sitemap')}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px 0',
                cursor: 'pointer',
                background: 'transparent'
              }}
            >
              <h5 style={{
                fontFamily: 'Prompt',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '1.25',
                color: '#000000',
                margin: 0
              }}>
                {t('footer.sitemap')}
              </h5>
              
              <svg 
                width="12" 
                height="7" 
                viewBox="0 0 12 7" 
                fill="none" 
                style={{
                  transform: accordionState['sitemap'] ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease',
                  color: accordionState['sitemap'] ? '#F4762A' : '#919192'
                }}
              >
                <path 
                  d="M1 1L6 6L11 1" 
                  stroke="currentColor" 
                  strokeWidth="1.5" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            {accordionState['sitemap'] && (
              <div style={{
                padding: '12px 0',
                animation: 'fadeIn 0.3s ease-in-out'
              }}>
                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: '8px' 
                }}>
                  {sitemapLinks.map((item, linkIndex) => (
                    <a key={linkIndex} href={item.link} style={{
                      fontFamily: 'Prompt',
                      fontWeight: 400,
                      fontSize: '12px',
                      lineHeight: '1.6',
                      color: '#575758',
                      textDecoration: 'none',
                      transition: 'color 0.2s ease',
                      padding: '2px 0'
                    }}>
                      {item.text}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Divider Line */}
        <div style={{
          width: '100%',
          height: '1px',
          backgroundColor: '#E1E1E2',
          margin: '24px 0'
        }} />

        {/* Company Info Section - Single Column like Desktop */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0px',
          marginBottom: '24px'
        }}>
          {/* Logo */}
          <div style={{
            width: '98px',
            height: '118px',
            position: 'relative'
          }}>
            <Image
              src="/assets/new-logo.png"
              alt="9asset Logo"
              fill
              sizes="(max-width: 768px) 98px, 98px"
              style={{ objectFit: 'contain' }}
              priority
            />
          </div>

          {/* Company Details */}
          <div style={{ marginTop: '30px' }}>
            <h6 style={{
              fontFamily: 'Prompt',
              fontWeight: 500,
              fontSize: '19px',
              lineHeight: '1.3',
              color: '#F4762A',
              margin: '0 0 8px 0'
            }}>
              {t('footer.company_name')}
            </h6>
            <p style={{
              fontFamily: 'Prompt',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '1.6',
              color: '#575758',
              margin: 0
            }}>
              {t('footer.company_address').split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < t('footer.company_address').split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
          </div>

          {/* Contact Info */}
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '4px',
            marginTop: '30px'
          }}>
            {/* Phone */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
              <span style={{
                fontFamily: 'Prompt',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '1.6',
                color: '#575758'
              }}>
                {t('footer.phone_label')}
              </span>
              <a href="tel:+66817131812" style={{
                fontFamily: 'Prompt',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '1.6',
                color: '#575758',
                textDecoration: 'none',
                transition: 'color 0.2s ease'
              }}
              onTouchStart={(e) => (e.target as HTMLAnchorElement).style.color = '#F4762A'}
              onTouchEnd={(e) => (e.target as HTMLAnchorElement).style.color = '#575758'}>
                {t('footer.phone_number')}
              </a>
            </div>

            {/* Email */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{
                fontFamily: 'Prompt',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '1.6',
                color: '#575758'
              }}>
                {t('footer.email_label')}
              </span>
              <a href="mailto:9asset.com@gmail.com" style={{
                fontFamily: 'Prompt',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '1.6',
                color: '#575758',
                textDecoration: 'none',
                transition: 'color 0.2s ease'
              }}
              onTouchStart={(e) => (e.target as HTMLAnchorElement).style.color = '#F4762A'}
              onTouchEnd={(e) => (e.target as HTMLAnchorElement).style.color = '#575758'}>
                {t('footer.email_address')}
              </a>
            </div>

            {/* Social Media */}
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '16px',
              marginTop: '8px'
            }}>
            {/* LinkedIn */}
            <a 
              href="https://linkedin.com/company/9asset" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#F4762A',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(244, 118, 42, 0.3)',
                textDecoration: 'none'
              }}
              onTouchStart={(e) => {
                const target = e.currentTarget as HTMLAnchorElement;
                target.style.transform = 'scale(1.1)';
                target.style.backgroundColor = '#e85a15';
                target.style.boxShadow = '0 4px 12px rgba(244, 118, 42, 0.5)';
              }}
              onTouchEnd={(e) => {
                const target = e.currentTarget as HTMLAnchorElement;
                target.style.transform = 'scale(1)';
                target.style.backgroundColor = '#F4762A';
                target.style.boxShadow = '0 2px 8px rgba(244, 118, 42, 0.3)';
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill="white"/>
              </svg>
            </a>

            {/* Facebook */}
            <a 
              href="https://facebook.com/9asset" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#F4762A',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(244, 118, 42, 0.3)',
                textDecoration: 'none'
              }}
              onTouchStart={(e) => {
                const target = e.currentTarget as HTMLAnchorElement;
                target.style.transform = 'scale(1.1)';
                target.style.backgroundColor = '#e85a15';
                target.style.boxShadow = '0 4px 12px rgba(244, 118, 42, 0.5)';
              }}
              onTouchEnd={(e) => {
                const target = e.currentTarget as HTMLAnchorElement;
                target.style.transform = 'scale(1)';
                target.style.backgroundColor = '#F4762A';
                target.style.boxShadow = '0 2px 8px rgba(244, 118, 42, 0.3)';
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" fill="white"/>
              </svg>
            </a>

            {/* YouTube */}
            <a 
              href="https://youtube.com/@9asset" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#F4762A',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(244, 118, 42, 0.3)',
                textDecoration: 'none'
              }}
              onTouchStart={(e) => {
                const target = e.currentTarget as HTMLAnchorElement;
                target.style.transform = 'scale(1.1)';
                target.style.backgroundColor = '#e85a15';
                target.style.boxShadow = '0 4px 12px rgba(244, 118, 42, 0.5)';
              }}
              onTouchEnd={(e) => {
                const target = e.currentTarget as HTMLAnchorElement;
                target.style.transform = 'scale(1)';
                target.style.backgroundColor = '#F4762A';
                target.style.boxShadow = '0 2px 8px rgba(244, 118, 42, 0.3)';
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="white"/>
              </svg>
            </a>

            {/* Instagram */}
            <a 
              href="https://instagram.com/9asset" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#F4762A',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(244, 118, 42, 0.3)',
                textDecoration: 'none'
              }}
              onTouchStart={(e) => {
                const target = e.currentTarget as HTMLAnchorElement;
                target.style.transform = 'scale(1.1)';
                target.style.backgroundColor = '#e85a15';
                target.style.boxShadow = '0 4px 12px rgba(244, 118, 42, 0.5)';
              }}
              onTouchEnd={(e) => {
                const target = e.currentTarget as HTMLAnchorElement;
                target.style.transform = 'scale(1)';
                target.style.backgroundColor = '#F4762A';
                target.style.boxShadow = '0 2px 8px rgba(244, 118, 42, 0.3)';
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="white"/>
              </svg>
            </a>

            {/* TikTok */}
            <a 
              href="https://tiktok.com/@9asset" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#F4762A',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 8px rgba(244, 118, 42, 0.3)',
                textDecoration: 'none'
              }}
              onTouchStart={(e) => {
                const target = e.currentTarget as HTMLAnchorElement;
                target.style.transform = 'scale(1.1)';
                target.style.backgroundColor = '#e85a15';
                target.style.boxShadow = '0 4px 12px rgba(244, 118, 42, 0.5)';
              }}
              onTouchEnd={(e) => {
                const target = e.currentTarget as HTMLAnchorElement;
                target.style.transform = 'scale(1)';
                target.style.backgroundColor = '#F4762A';
                target.style.boxShadow = '0 2px 8px rgba(244, 118, 42, 0.3)';
              }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" fill="white"/>
              </svg>
            </a>
            </div>
          </div>
        </div>

        {/* Bottom Section - Copyright and Back to Top */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          paddingTop: '28px',
          paddingBottom: '60px'
        }}>
          <p style={{
            fontFamily: 'Prompt',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '1.6',
            color: '#575758',
            margin: 0
          }}>
            {t('footer.copyright')} v{process.env.NEXT_PUBLIC_BUILD_NUMBER || '3.0.0'}
          </p>

          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'Prompt',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '1.6',
              color: '#000000',
              transition: 'color 0.2s ease',
              width: '132px',
              height: '28px'
            }}
          >
            Back to Top
            <svg width="17" height="17" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M8.5 1.5C4.35786 1.5 1 4.85786 1 9C1 13.1421 4.35786 16.5 8.5 16.5C12.6421 16.5 16 13.1421 16 9C16 4.85786 12.6421 1.5 8.5 1.5ZM0 9C0 4.30558 3.80558 0.5 8.5 0.5C13.1944 0.5 17 4.30558 17 9C17 13.6944 13.1944 17.5 8.5 17.5C3.80558 17.5 0 13.6944 0 9Z" fill="#F4762A"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M8.14645 6.14645C8.34171 5.95118 8.65829 5.95118 8.85355 6.14645L12.3536 9.64645C12.5488 9.84171 12.5488 10.1583 12.3536 10.3536C12.1583 10.5488 11.8417 10.5488 11.6464 10.3536L8.5 7.20711L5.35355 10.3536C5.15829 10.5488 4.84171 10.5488 4.64645 10.3536C4.45118 10.1583 4.45118 9.84171 4.64645 9.64645L8.14645 6.14645Z" fill="#F4762A"/>
            </svg>
          </button>
        </div>
      </div>

      {/* Add animation styles */}
      <style jsx>{`
        @keyframes fadeIn {
          0% {
            opacity: 0;
            transform: translateY(-10px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </footer>
  );
};

export default NewFooterMobile;
